import React from 'react';
import { Outlet } from 'react-router-dom';
import HeaderComponent from '../components/Header';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';
import Footer from '../components/Footer';

type Props = {
  allowPublic?: boolean;
};

const PolicyLayout: React.FC<Props> = ({ allowPublic }) => {
  const { loading } = useAuth();

  if (!allowPublic && loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="container">
      <HeaderComponent />
      <div className="main">
        <div className="content">
          <div className="div">
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default PolicyLayout;
